const actions = {

    OUTDOOR_INFO_DATA_BEGIN : 'OUTDOOR_INFO_DATA_BEGIN',
    OUTDOOR_INFO_DATA_SUCCESS: 'OUTDOOR_INFO_DATA_SUCCESS',
    OUTDOOR_INFO_DATA_ERR : 'OUTDOOR_INFO_DATA_ERR',

    OUTDOOR_INFO_PPT_LIST_DATA_BEGIN: 'OUTDOOR_INFO_PPT_LIST_DATA_BEGIN',
    OUTDOOR_INFO_PPT_LIST_DATA_SUCCESS: 'OUTDOOR_INFO_PPT_LIST_DATA_SUCCESS',
    OUTDOOR_INFO_PPT_LIST_DATA_ERR : 'OUTDOOR_INFO_PPT_LIST_DATA_ERR',
    OUTDOOR_INFO_PPT_LIST_DATA_RESET: 'OUTDOOR_INFO_PPT_LIST_DATA_RESET',

    OUTDOOR_INFO_PPT_DETAILS_DATA_BEGIN : 'OUTDOOR_INFO_PPT_DETAILS_DATA_BEGIN',
    OUTDOOR_INFO_PPT_DETAILS_DATA_SUCCESS: 'OUTDOOR_INFO_PPT_DETAILS_DATA_SUCCESS',
    OUTDOOR_INFO_PPT_DETAILS_DATA_ERR : 'OUTDOOR_INFO_PPT_DETAILS_DATA_ERR',
    OUTDOOR_INFO_PPT_DETAILS_DATA_RESET: 'OUTDOOR_INFO_PPT_DETAILS_DATA_RESET',

    OUTDOOR_CUSTOMER_INFO_DATA_BEGIN: 'OUTDOOR_CUSTOMER_INFO_DATA_BEGIN',
    OUTDOOR_CUSTOMER_INFO_DATA_SUCCESS: 'OUTDOOR_CUSTOMER_INFO_DATA_SUCCESS',
    OUTDOOR_CUSTOMER_INFO_DATA_ERR: 'OUTDOOR_CUSTOMER_INFO_DATA_ERR',
    OUTDOOR_CUSTOMER_INFO_DATA_RESET: 'OUTDOOR_CUSTOMER_INFO_DATA_RESET',

    OUTDOOR_FBO_DETAILS_DATA_BEGIN: 'OUTDOOR_FBO_DETAILS_DATA_BEGIN',
    OUTDOOR_FBO_DETAILS_DATA_SUCCESS: 'OUTDOOR_FBO_DETAILS_DATA_SUCCESS',
    OUTDOOR_FBO_DETAILS_DATA_ERR: 'OUTDOOR_FBO_DETAILS_DATA_ERR',
    OUTDOOR_FBO_DETAILS_DATA_RESET:'OUTDOOR_FBO_DETAILS_DATA_RESET',

    OUTDOOR_GET_EXCHANGE_DATA_BEGIN: 'OUTDOOR_GET_EXCHANGE_DATA_BEGIN',
    OUTDOOR_GET_EXCHANGE_DATA_SUCCESS: 'OUTDOOR_GET_EXCHANGE_DATA_SUCCESS',
    OUTDOOR_GET_EXCHANGE_DATA_ERR: 'OUTDOOR_GET_EXCHANGE_DATA_ERR',
    OUTDOOR_GET_EXCHANGE_DATA_RESET:'OUTDOOR_GET_EXCHANGE_DATA_RESET',

    OUTDOOR_HISTORY_DETAILS_BEGIN: 'OUTDOOR_HISTORY_DETAILS_BEGIN',
    OUTDOOR_HISTORY_DETAILS_SUCCESS: 'OUTDOOR_HISTORY_DETAILS_SUCCESS',
    OUTDOOR_HISTORY_DETAILS_ERR: 'OUTDOOR_HISTORY_DETAILS_ERR',

    OUTDOOR_VIEW_DETAILS_BEGIN: 'OUTDOOR_VIEW_DETAILS_BEGIN',
    OUTDOOR_VIEW_DETAILS_SUCCESS: 'OUTDOOR_VIEW_DETAILS_SUCCESS',
    OUTDOOR_VIEW_DETAILS_ERR: 'OUTDOOR_VIEW_DETAILS_ERR',

    OUTDOOR_FBO_HISTORY_DETAILS_BEGIN: 'OUTDOOR_FBO_HISTORY_DETAILS_BEGIN',
    OUTDOOR_FBO_HISTORY_DETAILS_SUCCESS: 'OUTDOOR_FBO_HISTORY_DETAILS_SUCCESS',
    OUTDOOR_FBO_HISTORY_DETAILS_ERR: 'OUTDOOR_FBO_HISTORY_DETAILS_ERR',

    OUTDOOR_FBO_VIEW_DETAILS_BEGIN: 'OUTDOOR_FBO_VIEW_DETAILS_BEGIN',
    OUTDOOR_FBO_VIEW_DETAILS_SUCCESS: 'OUTDOOR_FBO_VIEW_DETAILS_SUCCESS',
    OUTDOOR_FBO_VIEW_DETAILS_ERR: 'OUTDOOR_FBO_VIEW_DETAILS_ERR',

    OUTDOOR_START_TOKEN_BEGIN: 'OUTDOOR_START_TOKEN_BEGIN',
    OUTDOOR_START_TOKEN_SUCCESS: 'OUTDOOR_START_TOKEN_SUCCESS',
    OUTDOOR_START_TOKEN_ERR: 'OUTDOOR_START_TOKEN_ERR',
    OUTDOOR_START_TOKEN_RESET:'OUTDOOR_START_TOKEN_RESET',

    SUBMIT_MISSING_PPT_INFO_DATA_BEGIN: 'SUBMIT_MISSING_PPT_INFO_DATA_BEGIN',
    SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS: 'SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS',
    SUBMIT_MISSING_PPT_INFO_DATA_ERR: 'SUBMIT_MISSING_PPT_INFO_DATA_ERR',
    SUBMIT_MISSING_PPT_INFO_DATA_RESET: 'SUBMIT_MISSING_PPT_INFO_DATA_RESET',

    SUBMIT_PPT_INFO_DATA_BEGIN: 'SUBMIT_PPT_INFO_DATA_BEGIN',
    SUBMIT_PPT_INFO_DATA_SUCCESS: 'SUBMIT_PPT_INFO_DATA_SUCCESS',
    SUBMIT_PPT_INFO_DATA_ERR: 'SUBMIT_PPT_INFO_DATA_ERR',
    SUBMIT_PPT_INFO_DATA_RESET: 'SUBMIT_PPT_INFO_DATA_RESET',

    OUTDOOR_EXCHNAGE_PRICE_BEGIN: 'OUTDOOR_EXCHNAGE_PRICE_BEGIN',
    OUTDOOR_EXCHNAGE_PRICE_SUCCESS: 'OUTDOOR_EXCHNAGE_PRICE_SUCCESS',
    OUTDOOR_EXCHNAGE_PRICE_ERR: 'OUTDOOR_EXCHNAGE_PRICE_ERR',
    OUTDOOR_EXCHNAGE_PRICE_RESET: 'OUTDOOR_EXCHNAGE_PRICE_RESET',
    
    
    getOutdoorInfoDataBegin: () => {
        return {
            type: actions.OUTDOOR_INFO_DATA_BEGIN,
        };
    },

    getOutdoorInfoDataSuccess: (data) => {
        return {
            type: actions.OUTDOOR_INFO_DATA_SUCCESS,
            data,
        };
    },

    getOutdoorInfoDataErr: (err) => {
        return {
            type: actions.OUTDOOR_INFO_DATA_ERR,
            err,
        };
    },

    getPPTInfoListDataBegin : () => {
        return {
            type: actions.OUTDOOR_INFO_PPT_LIST_DATA_BEGIN,
        };
    },

    getPPTInfoListDataSuccess : (data) => {
        return {
            type: actions.OUTDOOR_INFO_PPT_LIST_DATA_SUCCESS,
            data,
        };
    },

    getPPTInfoListDataErr : (err) => {
        return {
            type: actions.OUTDOOR_INFO_PPT_LIST_DATA_ERR,
            err,
        };
    },

    getPPTInfoListDataReset : () => {
        return {
            type: actions.OUTDOOR_INFO_PPT_LIST_DATA_RESET,
        };
    },

    getPPTInfoDetailsDataBegin : () => {
        return {
            type: actions.OUTDOOR_INFO_PPT_DETAILS_DATA_BEGIN,
        };
    },

    getPPTInfoDetailsDataSuccess : (data) => {
        return {
            type: actions.OUTDOOR_INFO_PPT_DETAILS_DATA_SUCCESS,
            data,
        };
    },

    getPPTInfoDetailsDataErr : (err) => {
        return {
            type: actions.OUTDOOR_INFO_PPT_DETAILS_DATA_ERR,
            err,
        };
    },

    getPPTInfoDetailsDataReset : () => {
        return {
            type: actions.OUTDOOR_INFO_PPT_DETAILS_DATA_RESET,
        };
    },

    
    getCustomerTokenDataBegin : () => {
        return {
            type: actions.OUTDOOR_CUSTOMER_INFO_DATA_BEGIN,
        };
    },

    getCustomerTokenDataSuccess : (data) => {
        return {
            type: actions.OUTDOOR_CUSTOMER_INFO_DATA_SUCCESS,
            data,
        };
    },

    getCustomerTokenDataErr : (err) => {
        return {
            type: actions.OUTDOOR_CUSTOMER_INFO_DATA_ERR,
            err,
        };
    },

    getCustomerTokenDataReset : () => {
        return {
            type: actions.OUTDOOR_CUSTOMER_INFO_DATA_RESET,
        };
    },

    submitPPTInfomationDataBegin : () => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_BEGIN,
        };
    },

    submitPPTInfomationDataSuccess : (data) => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_SUCCESS,
            data,
        };
    },

    submitPPTInfomationDataErr : (err) => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_ERR,
            err,
        };
    },

    submitPPTInfomationDataReset : () => {
        return {
            type: actions.SUBMIT_PPT_INFO_DATA_RESET,
        };
    },

    submitFBODetailsDataBegin : () => {
        return {
            type: actions.OUTDOOR_FBO_DETAILS_DATA_BEGIN,
        };
    },

    submitFBODetailsDataSuccess : (data) => {
        return {
            type: actions.OUTDOOR_FBO_DETAILS_DATA_SUCCESS,
            data,
        };
    },

    submitFBODetailsDataErr : (err) => {
        return {
            type: actions.OUTDOOR_FBO_DETAILS_DATA_ERR,
            err,
        };
    },
    submitFBODetailsDataReset : () => {
        return {
            type: actions.OUTDOOR_FBO_DETAILS_DATA_RESET,
        };
    },

    getExchangeDetailsBegin : () => {
        return{
            type: actions.OUTDOOR_GET_EXCHANGE_DATA_BEGIN,
        }
    },

    getExchangeDetailsSuccess : (data) => {
        return {
            type: actions.OUTDOOR_GET_EXCHANGE_DATA_SUCCESS,
            data,
        };
    },

    getExchangeDetailsErr : (err) => {
        return {
            type: actions.OUTDOOR_GET_EXCHANGE_DATA_ERR,
            err,
        };
    },
    getExchangeDetailsReset : () => {
        return {
            type: actions.OUTDOOR_GET_EXCHANGE_DATA_RESET,
        };
    },

    submitMissingPPTBegin : () => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_BEGIN,
        };
    },

    submitMissingPPTSuccess : (data) => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_SUCCESS,
            data,
        };
    },

    submitMissingPPTErr : (err) => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_ERR,
            err,
        };
    },

    submitMissingPPTReset : () => {
        return {
            type: actions.SUBMIT_MISSING_PPT_INFO_DATA_RESET,
        };
    },

    getHistoryDetailsBegin : () => {
        return {
            type: actions.OUTDOOR_HISTORY_DETAILS_BEGIN,
        };
    },

    getHistoryDetailsSuccess : (data) => {
        return {
            type: actions.OUTDOOR_HISTORY_DETAILS_SUCCESS,
            data,
        };
    },

    getHistoryDetailsErr : (err) => {
        return {
            type: actions.OUTDOOR_HISTORY_DETAILS_ERR,
            err,
        };
    },
    getHistoryViewDetailsBegin : ()=>{
        return {
            type: actions.OUTDOOR_VIEW_DETAILS_BEGIN
        }
    },
    getHistoryViewDetailsSuccess : (data)=>{
        return {
            type: actions.OUTDOOR_VIEW_DETAILS_SUCCESS,
            data
        }
    },
    getHistoryViewDetailsErr : (err)=>{
        return {
            type: actions.OUTDOOR_VIEW_DETAILS_ERR,
            err
        }
    },

    getFBOHistoryDetailsBegin : () => {
        return {
            type: actions.OUTDOOR_FBO_HISTORY_DETAILS_BEGIN,
        };
    },

    getFBOHistoryDetailsSuccess : (data) => {
        return {
            type: actions.OUTDOOR_FBO_HISTORY_DETAILS_SUCCESS,
            data,
        };
    },

    getFBOHistoryDetailsErr : (err) => {
        return {
            type: actions.OUTDOOR_FBO_HISTORY_DETAILS_ERR,
            err,
        };
    },
    getFBOHistoryViewDetailsBegin : ()=>{
        return {
            type: actions.OUTDOOR_FBO_VIEW_DETAILS_BEGIN
        }
    },
    getFBOHistoryViewDetailsSuccess : (data)=>{
        return {
            type: actions.OUTDOOR_FBO_VIEW_DETAILS_SUCCESS,
            data
        }
    },
    getFBOHistoryViewDetailsErr : (err)=>{
        return {
            type: actions.OUTDOOR_FBO_VIEW_DETAILS_ERR,
            err
        }
    },

    postStartTokenBegin : () => {
        return{
            type: actions.OUTDOOR_START_TOKEN_BEGIN,
        }
    },

    postStartTokenSuccess : (data) => {
        return {
            type: actions.OUTDOOR_START_TOKEN_SUCCESS,
            data,
        };
    },

    postStartTokenErr : (err) => {
        return {
            type: actions.OUTDOOR_START_TOKEN_ERR,
            err,
        };
    },
    postStartTokenReset : () => {
        return {
            type: actions.OUTDOOR_START_TOKEN_RESET,
        };
    },
     postExchnagePriceBegin : () => {
        return{
            type: actions.OUTDOOR_EXCHNAGE_PRICE_BEGIN,
        }
    },

    postExchnagePriceSuccess : (data) => {
        return {
            type: actions.OUTDOOR_EXCHNAGE_PRICE_SUCCESS,
            data,
        };
    },

    postExchnagePriceErr : (err) => {
        return {
            type: actions.OUTDOOR_EXCHNAGE_PRICE_ERR,
            err,
        };
    },
    postExchnagePriceReset : () => {
        return {
            type: actions.OUTDOOR_EXCHNAGE_PRICE_RESET,
        };
    },
};

export default actions;
